import { updateGLEntity } from "../../../../../actions/Utilities/GLEntity";
import { useMutation } from "react-query";

const useUpdateGLEntity = () => {
  return useMutation(updateGLEntity);
};
export default useUpdateGLEntity;
